export const useElectron = () => {
  const { electron } = window;

  return {
    isElectron: !!electron,
    isMac: electron?.isMac ?? false,
    version: electron?.version,
  };
};
